import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  pegawaiSubkonService = {}

pegawaiSubkonService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai_subkon/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiSubkonService.show = function (token,data='') {
    return fetch({
        url: '/transaksi/pegawai_subkon/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

pegawaiSubkonService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_subkon/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiSubkonService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_subkon/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

pegawaiSubkonService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/pegawai_subkon/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default pegawaiSubkonService;
